import { render, staticRenderFns } from "./cailiaogl.vue?vue&type=template&id=8002970c&scoped=true&"
import script from "./cailiaogl.vue?vue&type=script&lang=js&"
export * from "./cailiaogl.vue?vue&type=script&lang=js&"
import style0 from "./cailiaogl.vue?vue&type=style&index=0&id=8002970c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8002970c",
  null
  
)

export default component.exports